var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _vm.element.formatInfo.openMode === "0"
        ? _c("time-default", {
            ref: _vm.element.id,
            attrs: { element: _vm.element },
          })
        : _vm._e(),
      _vm.element.formatInfo.openMode === "1"
        ? _c("time-elec", {
            ref: _vm.element.id,
            attrs: { element: _vm.element },
          })
        : _vm._e(),
      _vm.element.formatInfo.openMode === "2"
        ? _c("time-simple", {
            ref: _vm.element.id,
            attrs: { element: _vm.element },
          })
        : _vm._e(),
      _vm.element.formatInfo.openMode === "3"
        ? _c("time-complex", {
            ref: _vm.element.id,
            attrs: { element: _vm.element },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }